import React from 'react';
import clsx from 'clsx';
import { Reviews } from 'types/studio/studio';
import { Typography } from '@ag1/ui';
import styles from './styles.module.scss';
import ReviewsSliderButtons from '../ReviewsSliderButtons/ReviewsSliderButtons';
import { ReviewsSliderButtonsProps } from '../ReviewsSliderButtons/types';

type Props = Pick<Reviews, 'headline' | 'subtitle' | 'addSlider' | 'chevronColor'> &
  ReviewsSliderButtonsProps & {
    sliderActive: boolean;
    sectionType: string;
    textColor: string;
  };

const ReviewsHeading = ({
  sectionType,
  subtitle,
  headline,
  onScrollPrev,
  onScrollNext,
  sliderActive,
  textColor,
  chevronColor = 'dark'
}: Props) => {
  if (!headline && !subtitle && !sliderActive) {
    return null;
  }

  return (
    <div className={sliderActive ? styles.rootWithSlider : styles.root}>
      <div>
        {subtitle && (
          <strong className={styles.subtitle} style={{ color: textColor }}>
            {subtitle}
          </strong>
        )}
        {headline && (
          <Typography
            component="h2"
            variant="headlineSans"
            size="2"
            noPadding
            className={styles.headline}
            style={{ color: textColor }}>
            {headline}
          </Typography>
        )}
      </div>

      {sliderActive && (
        <div className={clsx(styles.buttons, !sliderActive && styles.hide)}>
          <ReviewsSliderButtons
            onScrollPrev={onScrollPrev}
            onScrollNext={onScrollNext}
            sectionType={sectionType}
            chevronColor={chevronColor}
          />
        </div>
      )}
    </div>
  );
};

export default ReviewsHeading;
